module.exports = __webpack_public_path__ + "img/imgs3.3ea47681.png";